import { JSONConfig, TopicLineJsonConfig } from '../types';
// TODO remove disabled eslint rule when more util functions are added
// eslint-disable-next-line import/prefer-default-export
export const getNavigationData = (navigation: Element, attribute: string): JSONConfig => {
  const emptyConfig: JSONConfig = {
    url: '',
    active_nav_root: '',
    active_page: '',
    flyout_breadcrumb: [],
    dictionary: {}
  };
  try {
    const data = navigation.getAttribute(attribute);
    if (data) {
      return JSON.parse(data);
    }
    return emptyConfig;
  } catch (error) {
    return emptyConfig;
  }
};

export const getTopicLineData = (themeWrapper: Element, attribute: string): TopicLineJsonConfig => {
  const emptyConfig: TopicLineJsonConfig = {
    headline: '',
    text: '',
    topicImage: {
      imageUrl:'',
      altText: ''
    },
    backBtnLabel: '',
    topicContent: {
      module:'',
      headline: '',
      text: '',
      number: '',
      inscription: '',
      image: {
        url: '',
        altText: ''
      }
    }
  };
  try {
    const data = themeWrapper.getAttribute(attribute);
    if (data) {
      return JSON.parse(data);
    }
    return emptyConfig;
  } catch (error) {
    return emptyConfig;
  }
};
